const trades = [
  { icon: "ri-flashlight-line", label: "Elektryk", color: "#FFC107" },
  { icon: "ri-drop-line", label: "Hydraulik", color: "#29B6F6" },
  { icon: "ri-home-3-line", label: "Dekarz", color: "#78909C" },
  { icon: "ri-road-map-line", label: "Brukarz", color: "#8D6E63" },
  { icon: "ri-community-line", label: "Ogrodzenia", color: "#66BB6A" },
  { icon: "ri-car-line", label: "Carporty", color: "#FF7043" },
  { icon: "ri-wind-line", label: "Klimatyzacja", color: "#26C6DA" },
  { icon: "ri-tools-line", label: "Remonty", color: "#AB47BC" },
  { icon: "ri-hammer-line", label: "Konstrukcje", color: "#EC407A" },
  { icon: "ri-paint-brush-line", label: "Malowanie", color: "#FFA726" },
  { icon: "ri-tree-line", label: "Ogrody", color: "#4CAF50" },
  { icon: "ri-more-line", label: "Inne usługi", color: "#0F2557" },
];

const ForWhomSection = () => {
  return (
    <section id="dla-kogo" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="inline-block text-[#1D4ED8] text-sm font-semibold tracking-wide uppercase mb-3">
            Dla kogo
          </span>
          <h2 className="text-3xl lg:text-4xl font-extrabold text-[#0F172A] mb-5 leading-tight">
            Dla kogo to jest
          </h2>
          <p className="text-[#64748B] text-lg leading-relaxed">
            Jeśli działasz lokalnie i chcesz więcej klientów z internetu — ta strona jest dla Ciebie.
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-4 lg:gap-5">
          {trades.map((trade) => (
            <div
              key={trade.label}
              className="bg-[#F8FAFF] rounded-xl p-5 flex flex-col items-center gap-3 border border-[#EFF6FF] hover:border-[#1D4ED8]/30 hover:bg-white transition-all cursor-default"
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-full"
                style={{ backgroundColor: `${trade.color}18` }}
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${trade.icon} text-xl`} style={{ color: trade.color }}></i>
                </div>
              </div>
              <span className="text-sm font-semibold text-[#1A1A2E] text-center">
                {trade.label}
              </span>
            </div>
          ))}
        </div>

        <p className="text-center text-[#94A3B8] text-sm mt-8">
          Nie widzisz swojej branży? Napisz — pomogę każdej lokalnej firmie usługowej.
        </p>
      </div>
    </section>
  );
};

export default ForWhomSection;
